import {
    Box,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    Typography,
    Chip,
} from '@mui/material';
import { useState } from 'react';
import { Media } from '@wwf/sdk';
import { MediaDialog } from './MediaDialog';
import { MediaContent } from './MediaContent';
import type { MediaResource } from './resourceMediaKind';
import { useListContext } from 'react-admin';
import { useConfigurationContext } from '@app/root/ConfigurationContext';

export const MediaIterator = () => {
    const { data, error, isPending } = useListContext<Media>();

    const [selectedMedia, setSelectedMedia] = useState<MediaResource | null>(
        null
    );

    if (isPending || error) return null;
    if (!data || data.length === 0) {
        return (
            <Box p={2}>
                <Typography color="textSecondary">No medias found.</Typography>
            </Box>
        );
    }

    return (
        <>
            <ImageList variant="masonry" cols={3} gap={8}>
                {data.map(item => (
                    <MediaItem
                        key={item.id}
                        item={item}
                        onMediaClick={setSelectedMedia}
                    />
                ))}
            </ImageList>

            <MediaDialog
                selectedMedia={selectedMedia}
                onClose={() => setSelectedMedia(null)}
            />
        </>
    );
};

const MediaItem = ({
    item,
    onMediaClick,
}: {
    item: Media;
    onMediaClick: (media: MediaResource) => void;
}) => {
    const { resourceTypeLabels } = useConfigurationContext();
    const label = resourceTypeLabels.find(label => label.value === item.type);
    if (!label) return null;

    return (
        <ImageListItem key={item.id}>
            <MediaContent item={item} onMediaClick={onMediaClick} />
            <ImageListItemBar
                position="below"
                title={
                    <Box display="flex" alignItems="center" gap={1}>
                        <Chip
                            label={label.label}
                            size="small"
                            color={label.color}
                        />
                        <Typography variant="body2">
                            {item.name || `${label.label} file`}
                        </Typography>
                    </Box>
                }
                subtitle={
                    <Box>
                        {item.authorId && (
                            <Typography variant="caption">
                                by {item.authorId}
                            </Typography>
                        )}
                        {item.description && (
                            <Typography
                                variant="caption"
                                display="block"
                                flexWrap="wrap"
                            >
                                {item.description}
                            </Typography>
                        )}
                    </Box>
                }
            />
        </ImageListItem>
    );
};
